import { styled } from '@linaria/react'
import { Dropdown } from '../Dropdown'

export const DropdownBrowseTemplate = styled(Dropdown)``

export const DropdownAccountTemplate = styled(Dropdown)``
